<div [ngxSummernote]="config" [(ngModel)]="textToEdit" (ngModelChange)="updateOriginalModel()"> </div>